<div class="modal-header">
  <h3 class="modal-title">
    {{ title | translate }}
  </h3>
  <button
    type="button"
    class="btn-close"
    attr.aria-label="{{ 'wcag.close' | translate }}"
    (click)="cancel()"
  >
  </button>
</div>

<div class="modal-body">
  <employee-booking-form
    [employeeBooking]="employeeBooking"
    (onSubmit)="onSubmit($event)"
    (onCancel)="onEmployeeBookingCancel($event)"
    [bookingIsAlreadyChecked]="bookingIsAlreadyChecked"
    [hasOnlyTrainerRole]="hasOnlyTrainerRole"
    [disableSaveButton$]="disableSaveButton$.asObservable()"
  ></employee-booking-form>
</div>
